/**
 * @fileoverview Renders buttons for controlling pagination and a select for limiting amount of info
 * displayed.
 *
 * This component supports cursor-based pagination, and will notify the parent's handler of changes.
 *
 * @author Brandon May (bmay@yext.com)
 */

goog.declareModuleId('yext.ui.components.CursorPaginationControls');

import {DeprecatedOldButton as Button} from '/ui/components/button/button';
import {NextButton, PreviousButton} from '/ui/components/pagination/paginationcontrols';
import {SelectController} from '/ui/components/select/selectcontroller';
import {Option} from '/ui/components/select/types/option';
import {yext} from '/ui/lib/msg';

const elemRoot = 'yext__cursor__pagination';

export const DEFAULT_LIMIT_OPTIONS = [
  {
    value: 25,
    label: yext.msg('25'),
  },
  {
    value: 50,
    label: yext.msg('50'),
  },
  {
    value: 100,
    label: yext.msg('100'),
  },
];

export const SMALL_LIMIT_OPTIONS = [
  {
    value: 5,
    label: yext.msg('5'),
  },
  {
    value: 10,
    label: yext.msg('10'),
  },
  {
    value: 25,
    label: yext.msg('25'),
  },
];

/**
 * @param {{
 *   loading: boolean,
 *   limit: number,
 *   limitOptions?: !Array<Option>,
 *   onLimitChange: (function(number):void),
 *   onPrevPageClick?: (function():void),
 *   onNextPageClick?: (function():void),
 *   tid?: string,
 * }} props
 *
 * @return {React.ReactElement}
 */
export const CursorPaginationControls = function(props) {
  const {
    loading,
    limit,
    limitOptions = DEFAULT_LIMIT_OPTIONS,
    onLimitChange,
    onPrevPageClick,
    onNextPageClick,
    tid,
  } = props;

  /**
   * Called when changing show.
   * @param {number} newLimit
   */
  const handleLimitChange = newLimit => {
    if (newLimit === limit) {
      return;
    }
    onLimitChange(newLimit);
  };

  return (
    <div className={elemRoot} tid={tid}>
      <div className={`${elemRoot}__info ${elemRoot}__item`}>
        <span>{yext.msg('Show')}</span>
      </div>
      <div className={`${elemRoot}__controls ${elemRoot}__item`}>
        <div className={`${elemRoot}__controls__select`}>
          <SelectController
            config={{
              name: 'basic-short',
              onSelect: handleLimitChange,
              disabled: loading,
            }}
            options={limitOptions}
            selectedOptions={[limit]}
          />
        </div>
      </div>
      <div className={`${elemRoot}__controls ${elemRoot}__item`}>
        <PreviousButton
          disabled={loading || !onPrevPageClick}
          onClick={onPrevPageClick}
        />
        <NextButton
          disabled={loading || !onNextPageClick}
          onClick={onNextPageClick}
        />
      </div>
    </div>
  );
};
